const FromArrEditor = [

	{
		key: 'Year',
		modelvalue: undefined,
		title: "年度：",
		inputtype: "select",
		inputflag: true,
		fontSize: 14,
		color: "#333333",
		lableheight: 20,
		X: false,
		types: "",
		placeholder: "请选择",
		width: 210,
		height: 32,
		disabled: false,
		marginLeft: 60,
		marginTop: 5,
		displayVal: "inline-block",
		fontWeightVal: 500,
		options: [],
	}, {
		key: 'InvClass',
		modelvalue: undefined,
		title: "产品线：",
		inputtype: "select",
		inputflag: true,
		fontSize: 14,
		color: "#333333",
		lableheight: 20,
		X: false,
		types: "",
		placeholder: "请选择",
		width: 210,
		height: 32,
		disabled: false,
		marginLeft: 60,
		marginTop: 5,
		displayVal: "inline-block",
		fontWeightVal: 500,
		options: [],
	},

	{
		key: 'JanRatio',
		modelValue: undefined,
		title: "一月分摊比例：",
		inputtype: "NumberInput",
		inputflag: true,
		fontSize: 14,
		color: "#333333",
		lableheight: 20,
		X: false,
		types: "text",
		placeholder: "请输入",
		width: 210,
		height: 32,
		disabled: false,
		marginLeft: -632,
		marginTop: 55,
		displayVal: "inline-block",
		fontWeightVal: 500,
		max: undefined,
		min: 0
	},
	{
		key: 'FebRatio',
		modelValue: undefined,
		title: "二月分摊比例：",
		inputtype: "NumberInput",
		inputflag: true,
		fontSize: 14,
		color: "#333333",
		lableheight: 20,
		X: false,
		types: "text",
		placeholder: "请输入",
		width: 210,
		height: 32,
		disabled: false,
		marginLeft: 50,
		marginTop: 55,
		displayVal: "inline-block",
		fontWeightVal: 500,
		max: undefined,
		min: 0
	},
	{
		key: 'MarRatio',
		modelValue: undefined,
		title: "三月分摊比例：",
		inputtype: "NumberInput",
		inputflag: true,
		fontSize: 14,
		color: "#333333",
		lableheight: 20,
		X: false,
		types: "text",
		placeholder: "请输入",
		width: 210,
		height: 32,
		disabled: false,
		marginLeft: 710,
		marginTop: -32,
		displayVal: "inline-block",
		fontWeightVal: 500,
		max: undefined,
		min: 0
	},
	{
		key: 'AprRatio',
		modelValue: undefined,
		title: "四月分摊比例：",
		inputtype: "NumberInput",
		inputflag: true,
		fontSize: 14,
		color: "#333333",
		lableheight: 20,
		X: false,
		types: "text",
		placeholder: "请输入",
		width: 210,
		height: 32,
		disabled: false,
		marginLeft: 5,
		marginTop: 20,
		displayVal: "inline-block",
		fontWeightVal: 500,
		max: undefined,
		min: 0
	},
	{
		key: 'MayRatio',
		modelValue: undefined,
		title: "五月分摊比例：",
		inputtype: "NumberInput",
		inputflag: true,
		fontSize: 14,
		color: "#333333",
		lableheight: 20,
		X: false,
		types: "text",
		placeholder: "请输入",
		width: 210,
		height: 32,
		disabled: false,
		marginLeft: 50,
		marginTop: 20,
		displayVal: "inline-block",
		fontWeightVal: 500,
		max: undefined,
		min: 0
	},
	{
		key: 'JunRatio',
		modelValue: undefined,
		title: "六月分摊比例：",
		inputtype: "NumberInput",
		inputflag: true,
		fontSize: 14,
		color: "#333333",
		lableheight: 20,
		X: false,
		types: "text",
		placeholder: "请输入",
		width: 210,
		height: 32,
		disabled: false,
		marginLeft: 710,
		marginTop: -32,
		displayVal: "inline-block",
		fontWeightVal: 500,
		max: undefined,
		min: 0
	},
	{
		key: 'JulRatio',
		modelValue: undefined,
		title: "七月分摊比例：",
		inputtype: "NumberInput",
		inputflag: true,
		fontSize: 14,
		color: "#333333",
		lableheight: 20,
		X: false,
		types: "text",
		placeholder: "请输入",
		width: 210,
		height: 32,
		disabled: false,
		marginLeft: 5,
		marginTop: 20,
		displayVal: "inline-block",
		fontWeightVal: 500,
		max: undefined,
		min: 0
	},
	{
		key: 'AugRatio',
		modelValue: undefined,
		title: "八月分摊比例：",
		inputtype: "NumberInput",
		inputflag: true,
		fontSize: 14,
		color: "#333333",
		lableheight: 20,
		X: false,
		types: "text",
		placeholder: "请输入",
		width: 210,
		height: 32,
		disabled: false,
		marginLeft: 50,
		marginTop: 20,
		displayVal: "inline-block",
		fontWeightVal: 500,
		max: undefined,
		min: 0
	},
	{
		key: 'SepRatio',
		modelValue: undefined,
		title: "九月分摊比例：",
		inputtype: "NumberInput",
		inputflag: true,
		fontSize: 14,
		color: "#333333",
		lableheight: 20,
		X: false,
		types: "text",
		placeholder: "请输入",
		width: 210,
		height: 32,
		disabled: false,
		marginLeft: 710,
		marginTop: -32,
		displayVal: "inline-block",
		fontWeightVal: 500,
		max: undefined,
		min: 0
	},
	{
		key: 'OctRatio',
		modelValue: undefined,
		title: "十月分摊比例：",
		inputtype: "NumberInput",
		inputflag: true,
		fontSize: 14,
		color: "#333333",
		lableheight: 20,
		X: false,
		types: "text",
		placeholder: "请输入",
		width: 210,
		height: 32,
		disabled: false,
		marginLeft: 5,
		marginTop: 20,
		displayVal: "inline-block",
		fontWeightVal: 500,
		max: undefined,
		min: 0
	},
	{
		key: 'NovRatio',
		modelValue: undefined,
		title: "十一月分摊比例：",
		inputtype: "NumberInput",
		inputflag: true,
		fontSize: 14,
		color: "#333333",
		lableheight: 20,
		X: false,
		types: "text",
		placeholder: "请输入",
		width: 210,
		height: 32,
		disabled: false,
		marginLeft: 35,
		marginTop: 20,
		displayVal: "inline-block",
		fontWeightVal: 500,
		max: undefined,
		min: 0
	},
	{
		key: 'DecRatio',
		modelValue: undefined,
		title: "十二月分摊比例：",
		inputtype: "NumberInput",
		inputflag: true,
		fontSize: 14,
		color: "#333333",
		lableheight: 20,
		X: false,
		types: "text",
		placeholder: "请输入",
		width: 210,
		height: 32,
		disabled: false,
		marginLeft: 695,
		marginTop: -32,
		displayVal: "inline-block",
		fontWeightVal: 500,
		max: undefined,
		min: 0
	},
];
export default FromArrEditor;
